import React, { PureComponent } from 'react'
import Link from 'components/ui/Link/Link'
import cx from 'classnames'
import { localStorage } from 'helpers'


import CollapsibleList from 'components/ui/CollapsibleList/CollapsibleList'
import ToggleList from '../../../Header/ToggleList/ToggleList'

import s from './DropLink.scss'


class DropLink extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      active: props.localStorageName ? localStorage.getItem(props.localStorageName) : false
    }
  }

  componentDidMount() {
    const { localStorageName } = this.props

    if (localStorageName) {
      window.addEventListener('pageNav', this.handleSetActive)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('pageNav', this.handleSetActive)
  }

  handleSetActive = () => {
    const { active } = this.state
    const { localStorageName } = this.props

    localStorage.setItem(localStorageName, !active)

    console.log('setActive', !active)
    this.setState({
      active: !active,
    })
  }

  render() {
    const { active } = this.state
    const { title, link, toOLD, subNav, localStorageName, onClick } = this.props

    const hasItems = Boolean(subNav && subNav.length)

    if (!subNav) {
      console.log({ link })
      return (
        <Link
          className={cx(s.link, {
            [s.active]: active,
          })}
          activeClassName={s.active}
          to={link}
          toOLD={toOLD}
          onClick={onClick}
        >
          <div dangerouslySetInnerHTML={{ __html: title }}/>
        </Link>
      )
    }

    return (
      <CollapsibleList
        titleClassName={cx(s.link, {
          [s.transparent]: subNav && !subNav.length,
        })}
        title={title}
        isAbsolute
        withToggleArrow={hasItems}
      >
        <ToggleList
          links={(
            subNav.map(({ id, title, selected, onClick }) => (
              {
                title,
                onClick,
              }
            ))
          )}
        />
      </CollapsibleList>
    )
  }
}


export default DropLink
